import salomapi from '../apis';

export const postZipcode = (zip,region) => async dispach => {
    const response = await salomapi.get(`/channelfinder?zipcode=${zip}&region=${region}`);
    return response.data;
}